import { render, staticRenderFns } from "./ChangeView.vue?vue&type=template&id=38af31d1&scoped=true&"
import script from "./ChangeView.vue?vue&type=script&lang=ts&"
export * from "./ChangeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38af31d1",
  null
  
)

export default component.exports